module.exports = __webpack_public_path__ + "static/media/clipboard.f8b9905b.svg";